import {
  GetEssEnergyAnalysisStats,
  GetEssEnergyConversionStats,
  GetEssStationFlowData,
  GetEssStationOverview,
} from '@/api/evses'
import { EssEnergyChart, GetEssStationOverviewReply } from '@/types/common/station'
import { onMounted, onUnmounted, ref } from 'vue'
import { GetEssEnergyConversionStatsReply } from '../Photovoltaic/types'
import { EssEnergyFlow } from '@/types/types'

export const useStationData = (stationId: string) => {
  const stationInfoData = ref<GetEssStationOverviewReply>()
  let setTimeFlowDataId: ReturnType<typeof setInterval> | null = null
  let setTimeStationDataId: ReturnType<typeof setInterval> | null = null

  const fetchEssStationStatus = () => {
    GetEssStationOverview({ stationId }).then((res: GetEssStationOverviewReply) => {
      stationInfoData.value = res
    })
  }

  const essEnergyConversionStats = ref<Partial<GetEssEnergyConversionStatsReply>>({})
  const fetchEssEnergyConversionStats = () => {
    GetEssEnergyConversionStats({ stationId }).then((res: GetEssEnergyConversionStatsReply) => {
      essEnergyConversionStats.value = res
    })
  }

  const essStationFlowData = ref<Partial<EssEnergyFlow>>({})
  const fetchEssStationFlowData = () => {
    GetEssStationFlowData({
      stationId,
    }).then((res: { flowData: EssEnergyFlow }) => {
      essStationFlowData.value = res.flowData
    })
  }

  const startIntervalFlowData = () => {
    setTimeFlowDataId = setInterval(() => {
      fetchEssStationFlowData()
    }, 5 * 1000)
  }
  const startIntervalStationData = () => {
    setTimeStationDataId = setInterval(() => {
      fetchEssStationStatus()
    }, 30 * 1000)
  }

  onMounted(() => {
    fetchEssStationStatus()
    fetchEssEnergyConversionStats()
    fetchEssStationFlowData()
  })
  onUnmounted(() => {
    if (setTimeFlowDataId) {
      clearInterval(setTimeFlowDataId)
    }
    if (setTimeStationDataId) {
      clearInterval(setTimeStationDataId)
    }
  })
  return {
    stationInfoData,
    essEnergyConversionStats,
    essStationFlowData,
    fetchEssStationStatus,
    startIntervalFlowData,
    startIntervalStationData,
  }
}
